import Lenis from 'lenis';
import 'lenis/dist/lenis.css';

let lenis = null;
let locks = 0;

// Starts Lenis smooth scrolling; returns a cleanup function.
export function initSmoothScroll() {
  // Respect the OS "reduce motion" setting — fall back to native scrolling
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return () => {};

  lenis = new Lenis({ autoRaf: true });
  if (locks > 0) lenis.stop();

  return () => {
    lenis.destroy();
    lenis = null;
  };
}

// Smooth-scrolls the page to a pixel offset from the top.
export function scrollToY(top) {
  if (lenis) lenis.scrollTo(top, { duration: 1.1 });
  else window.scrollTo({ top, behavior: 'smooth' });
}

// Freezes page scroll while a popup or menu is open. The scrollbar's width is
// handed to CSS as --scrollbar-gap so the page and navbar don't shift sideways
// when the scrollbar disappears. Calls are counted, so popups can overlap.
export function lockScroll() {
  if (locks++ > 0) return;
  const root = document.documentElement;
  root.style.setProperty('--scrollbar-gap', `${window.innerWidth - root.clientWidth}px`);
  document.body.style.overflow = 'hidden';
  if (lenis) lenis.stop();
}

export function unlockScroll() {
  if (locks === 0 || --locks > 0) return;
  document.body.style.overflow = '';
  document.documentElement.style.removeProperty('--scrollbar-gap');
  if (lenis) lenis.start();
}
